<template>
  <div>
    <CCard>
      <CCardHeader>
        <CIcon name="cil-grid"/> Inactive Life Policies
      </CCardHeader>
      <PoliciesTable />
    </CCard> 
  </div>
</template>

<script>
import PoliciesTable from "@/components/InactiveLifeTable"
export default {
  components:{
    PoliciesTable
  }
}
</script>

<style>

</style>